import React from 'react'
import { css } from '../style/styles'

const Stats = ({ contracts }) => {
    const list = contracts?.data || (Array.isArray(contracts) ? contracts : []);
    const totalCount = contracts?.total || list.length;

    const isFullySigned = (c) => !!((c?.employeeSignature || c?.employee_signature) && (c?.managerSignature || c?.manager_signature));
    const isTerminated = (c) => c?.status === "terminated";
    const isWaitingBoth = (c) => !isTerminated(c) && !c?.employeeSignature && !c?.employee_signature && !c?.managerSignature && !c?.manager_signature;

    const terminatedCount = list.filter(isTerminated).length;
    const activeCount = list.filter(c => !isTerminated(c) && isFullySigned(c)).length;
    const pendingCount = list.filter(isWaitingBoth).length;
    const laborCount = list.filter(c => c?.type === "labor").length;
    const collaboratorCount = list.filter(c => c?.type === "collaborator").length;

    return (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(130px, 1fr))", gap: 10, marginBottom: 16 }}>
            {[
                { label: "Tổng hợp đồng", value: totalCount, color: "#3b82f6", icon: "📋" },
                { label: "Đang hiệu lực", value: activeCount, color: "#10b981", icon: "🟢" },
                { label: "Đang chờ 2 bên ký", value: pendingCount, color: "#f59e0b", icon: "🟠" },
                { label: "Đã kết thúc", value: terminatedCount, color: "#ef4444", icon: "🔴" },
                { label: "HĐ Lao động", value: laborCount, color: "#6366f1", icon: "👔" },
                { label: "Cộng tác viên", value: collaboratorCount, color: "#8b5cf6", icon: "🤝" },
            ].map(s => (
                <div key={s.label} style={{ ...css.card, padding: "10px 14px", marginBottom: 0, borderLeft: `3px solid ${s.color}` }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        <span style={{ fontSize: 16 }}>{s.icon}</span>
                        <span style={{ fontSize: 18, fontWeight: 800, color: s.color }}>{s.value}</span>
                    </div>
                    <div style={{ fontSize: 11, color: "#64748b", marginTop: 4, fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                        {s.label}
                    </div>
                </div>
            ))}
        </div>
    )
}

export default React.memo(Stats)
